import type { ApiRoute, NoPathParams, NoQueryParams, NoResponse } from "../api"

export interface UpdateNotificationsBody {
	ids: string[]
	status: "SEEN" | "READ"
}

export const updateNotificationsRoute: ApiRoute<NoPathParams, NoQueryParams, UpdateNotificationsBody, NoResponse> = {
	buildUrl: () => "/notification-list/status",
	method: "patch",
	path: "/notification-list/status",
}
